{
  "sidebar": {
    "operators": "Operatori",
    "admins": "Administratori",
    "formBuilder": "Forme",
    "incidentSubmissions": "Incidenti",
    "submittedForms": "Poslati Formulari",
    "signOut": "Odjavi se",
    "profile": "Profil",
    "companies": "Privredni subjekti",
    "activityLogs": "Evidencija",
    "avoidedIncidents": "Izbegnuti incidenti"
  },
  "common": {
    "yes": "Da",
    "no": "Ne",
    "filters": "Filteri",
    "apply": "Primeni",
    "actions": "Akcije",
    "select": "Izaberi",
    "deletedUser": "Obrisan korisnik",
    "deletedEntity": "Obrisano",
    "page": "Strana",
    "currentFile": "Trenutni fajl",
    "newFile": "Novi fajl",
    "uploadEmpty": "Kliknite da otpremite",
    "uploadNewFile": "Otpremite novi fajl",
    "of": "od",
    "currency": "RSD",
    "hour": "sat",
    "switchTooltip": "Aktivnost",
    "next": "Sledeće",
    "previous": "Prethodno",
    "submit": "Pošalji",
    "back": "Nazad",
    "locked": "Zaključan",
    "unlocked": "Otključan",
    "on": "ON",
    "off": "OFF",
    "noData": "Nema podataka",
    "noValue": "Nema vrednosti",
    "performingAction": "Izvršavanje akcije...",
    "otherInputPlaceholder": "Unesite drugi tekst...",
    "otherAnswerLabel": "Drugi odgovor",
    "otherNumberPlaceholder": "Unesite broj...",
    "otherNumericInputLabel": "Broj korisnika pogođenih incidentom",
    "enums": {
      "incidentStatus": {
        "status": "Status",
        "REPORTED": "Prijavljen incident",
        "REPORT_SUBMITTED": "Dostavljeno dodatno obaveštenje",
        "ADDITIONAL_REPORT_SUBMITTED": "Dostavljen dodatni izveštaj",
        "CLOSED": "Dostavljen završni izveštaj",
        "DISMISSED": "Otklonjen"
      },
      "mediaType": {
        "UNKNOWN": "Nepoznato",
        "IMAGE": "Slika",
        "VIDEO": "Video",
        "SVG": "SVG",
        "AUDIO": "Audio",
        "PDF": "PDF",
        "WORD": "Word dokument",
        "ARCHIVE": "Arhiva"
      }
    },
    "errors": {
      "email": "Polje mora biti validna email adresa",
      "minlength": "Polje mora imati najmanje {{requiredLength}} karaktera. Trenutna dužina je {{actualLength}}",
      "required": "Polje je obavezno",
      "maxlength": "Polje može imati najviše {{requiredLength}} karaktera. Trenutna dužina je {{actualLength}}",
      "pattern": "Polje mora odgovarati šablonu {{requiredPattern}}",
      "min": "Polje mora biti najmanje {{min}}",
      "max": "Polje može biti najviše {{max}}",
      "websitePattern": "Molimo unesite validan URL sajta (npr. https://example.com)",
      "durationPattern": "Molimo unesite validno trajanje u formatu {{durationLabel}}",
      "mustMatchPassword": "Lozinke se ne podudaraju",
      "strongPassword": "Lozinka mora biti najmanje 8 karaktera, sadržavati najmanje jedan veliki broj, jedan mali broj i jedan poseban karakter",
      "pageNotFound": "Nema aktivnih formi",
      "pageNotFoundDescription": "Nema aktivnih formi. Molimo, pokušajte ponovno kasnije ili kontaktirajte podršku.",
      "startsWith": "Polje mora početi sa {{startsWith}} i sadržati samo cifre",
      "minDate": "Datum mora biti posle {{minDate}}",
      "maxDate": "Datum mora biti pre {{maxDate}}",
      "step": "Polje mora biti umnožak od {{step}}",
      "operatorIdMissing": "Obavezno je izabrati operatora pre popunjavanja formulara"
    },
    "toast": {
      "success": "Uspeh",
      "warning": "Upozorenje",
      "error": "Greška"
    },
    "reportType": {
      "title": "Šta prijavljujete?",
      "description": "Izaberite vrstu prijave da biste otvorili odgovarajući formular.",
      "incident": "Incident",
      "incidentDescription": "Incident koji se dogodio u IKT sistemu.",
      "avoided": "Izbegnuti incident",
      "avoidedDescription": "Incident koji je sprečen pre nego što je nastupio.",
      "change": "Promeni vrstu prijave",
      "downloadPdf": "Preuzmi PDF obrazac"
    }
  },
  "confirmations": {
    "delete": "Obrisati ovu stavku?",
    "submitForm": "Da li ste sigurni da želite da pošaljete formular?"
  },
  "buttons": {
    "no": "Otkaži",
    "yes": "Potvrdi"
  },
  "fileDownload": {
    "downloading": "Započinje preuzimanje fajla"
  },
  "auth": {
    "forgotPassword": "Zaboravili ste lozinku?",
    "login": "Prijavite se",
    "returnToLogin": "Vratite se na prijavu",
    "sendEmail": "Pošaljite email",
    "resetPassword": "Resetujte lozinku",
    "register": "Registrujte se",
    "alreadyHaveAccount": "Već imate nalog?",
    "otpCode": "OTP kod",
    "otpExpiresIn": "Ističe za",
    "otpExpired": "OTP kod je istekao, molimo pokušajte ponovo",
    "fields": {
      "name": "Ime",
      "email": "Email",
      "password": "Lozinka",
      "repeatPassword": "Ponovite lozinku"
    }
  },
  "submittedForms": {
    "all": {
      "title": "Svi Poslati Formulari",
      "description": "Pregled i upravljanje svim poslatim formularijima za incidente"
    },
    "single": {
      "title": "Detalji Poslatog Formulara",
      "description": "Pregled detaljnih informacija o poslatom formularu",
      "submittedBy": "Poslao",
      "submittedAt": "Vreme slanja",
      "id": "ID",
      "noFields": "Nema polja za prikaz",
      "noData": "Nema podataka",
      "noDataDescription": "Ovaj formular ne sadrži podatke za prikaz"
    },
    "filter": {
      "search": "Pretraga",
      "searchPlaceholder": "Pretražite",
      "date": "Opseg Datuma",
      "datePlaceholder": "Izaberite opseg datuma"
    },
    "fields": {
      "id": "ID",
      "uuid": "UUID",
      "name": "Ime",
      "status": "Status",
      "submitted_at": "Poslato"
    }
  },
  "languagePicker": {
    "en": "English",
    "sr": "Srpski (latinica)",
    "cyr": "Српски (ћирилица)"
  },
  "languages": {
    "en": "Engleski",
    "sr": "Srpski (latinica)",
    "cyr": "Srpski (ćirilica)"
  },
  "primeng": {
    "multiselect": {
      "selectedItemsLabel": "{0} stavke izabrane"
    }
  }
}
